import Dashboard from "../../pages/hire-talent/dashboard";
import JobDetails from "../../pages/common/JobDetails";
import JobPost from "../../pages/hire-talent/JobPost";
import MyProjects from "../../pages/hire-talent/MyProjects";
import Inbox from "../../pages/hire-talent/Inbox";

export const hireTalentPaths = {
  Dashboard: "/hire-talent/dashboard",
  PostJobs: "/hire-talent/job-post",
  JobDetails: "/hire-talent/job-details",
  MyProjects: "/hire-talent/my-projects",
  Inbox: "/hire-talent/inbox",
};

export const AllHireTalentRoutes = [
  {
    name: "Dashboard",
    path: hireTalentPaths?.Dashboard,
    element: <Dashboard />,
    isPrivate: false,
  },
  {
    name: "Job Post",
    path: hireTalentPaths?.PostJobs,
    element: <JobPost />,
    isPrivate: false,
  },
  {
    name: "JobDetails",
    path: hireTalentPaths.JobDetails,
    element: <JobDetails />,
    isPrivate: false,
  },
  {
    name: "MyProjects",
    path: hireTalentPaths?.MyProjects,
    element: <MyProjects />,
    isPrivate: false,
  },
  {
    name: "Inbox",
    path: hireTalentPaths?.Inbox,
    element: <Inbox />,
    isPrivate: false,
  },
];